export default {
    expressImage(name) {
        if (name == 'STO') return '../../static/icon/sto_logo.jpg'
        else if (name == 'DBL') return '../../static/icon/dbl_logo.jpg'
        else if (name == 'ANE') return '../../static/icon/ane_logo.jpg'
        else if (name == 'EMS') return '../../static/icon/ems_logo.jpg'
        else if (name == 'GTO') return '../../static/icon/gto_logo.jpg'
        else if (name == 'HHTT') return '../../static/icon/hhtt_logo.jpg'
        else if (name == 'HTKY') return '../../static/icon/htky_logo.jpg'
        else if (name == 'JD') return '../../static/icon/jd_logo.jpg'
        else if (name == 'JDKY') return '../../static/icon/jdky_logo.jpg'
        else if (name == 'LB') return '../../static/icon/lb_logo.jpg'
        else if (name == 'PJ') return '../../static/icon/pj_logo.jpg'
        else if (name == 'SURE') return '../../static/icon/sure_logo.jpg'
        else if (name == 'UAPEX') return '../../static/icon/uapex_logo.jpg'
        else if (name == 'UC') return '../../static/icon/uc_logo.jpg'
        else if (name == 'XFEX') return '../../static/icon/xfex_logo.jpg'
        else if (name == 'YCWL') return '../../static/icon/ycwl_logo.jpg'
        else if (name == 'YD') return '../../static/icon/yd_logo.jpg'
        else if (name == 'YTO') return '../../static/icon/yto_logo.jpg'
        else if (name == 'YZBK') return '../../static/icon/yzbk_logo.jpg'
        else if (name == 'YZPY') return '../../static/icon/yzpy_logo.jpg'
        else if (name == 'ZJS') return '../../static/icon/zjs_logo.jpg'
        else if (name == 'ZTKY') return '../../static/icon/ztky_logo.jpg'
        else if (name == 'ZTO') return '../../static/icon/zto_logo.jpg'
		else if (name == 'SF') return '../../static/icon/sf_logo.jpg'
		else if (name == 'SFTK') return '../../static/icon/sf_logo.jpg'
		else if (name == 'SFBK') return '../../static/icon/sf_logo.jpg'

        return '../../static/icon/sf_logo.jpg'
    },
    expressCName(name) {
        if (name == 'STO') return '申通快递'
        else if (name == 'DBL') return '德邦快递'
        else if (name == 'ANE') return '安能快递'
        else if (name == 'EMS') return 'EMS'
        else if (name == 'GTO') return '国通'
        else if (name == 'HHTT') return '天天快递'
        else if (name == 'HTKY') return '百世快递'
        else if (name == 'JD') return '京东'
        else if (name == 'JDKY') return '京东快运'
        else if (name == 'LB') return '龙邦快递'
        else if (name == 'PJ') return '品骏快递'
        else if (name == 'SURE') return '德尔快递'
        else if (name == 'UAPEX') return '全一快递'
        else if (name == 'UC') return 'UC快递'
        else if (name == 'XFEX') return '信丰快递'
        else if (name == 'YCWL') return '远成快递'
        else if (name == 'YD') return '韵达快递'
        else if (name == 'YTO') return '圆通快递'
        else if (name == 'YZBK') return '中国邮政'
        else if (name == 'YZPY') return '中国邮政'
        else if (name == 'ZJS') return '宅急送'
        else if (name == 'ZTKY') return '中铁快运'
        else if (name == 'ZTO') return '中通快递'
		else if (name == 'SF') return '顺丰速递'
		else if (name == 'SFTK') return '顺丰特快'
		else if (name == 'SFBK') return '顺丰标快'
		else if (name == 'SFLY') return '顺丰陆运'
        return '顺丰速递'
    },
    expressPayTypeName(paytype) {
		//3  寄付就是月结
        if (paytype == 2) return '到付'
        else if (paytype == 3) return '寄付'
        return '现付'

    },
    //通过顺丰到付或顺丰寄付获取类型编号
    expressNameToPayType(name) {
		//3  寄付就是月结
        if (name.indexOf('到付') != -1) return 2
        else if (name.indexOf('寄付') != -1) return 3
        return 1
    },

    //通过顺丰到付或顺丰寄付获取SF这样的代码
    expressNameToExpressType(name) {
        if (name.indexOf('德邦') != -1) return 'DBL'
        else if (name.indexOf('申通') != -1) return 'STO'
        else if (name.indexOf('京东快运') != -1) return 'JDKY'
        else if (name.indexOf('京东') != -1) return 'JD'
		else if (name.indexOf('顺丰特快') != -1) return 'SFTK'
		else if (name.indexOf('顺丰标快') != -1) return 'SFBK'
		else if (name.indexOf('顺丰陆运') != -1) return 'SFLY'
        return "SF"
    },
    isReceipt(code) {//是否为发票数据
        if (code.split(',').length == 9) {
            return true
        }
        
        return false
    }
}


// WEBPACK FOOTER //
// ./src/js/tool.js